import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';
import { Apollo, QueryRef } from 'apollo-angular';
import { take, tap, pluck, withLatestFrom } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';

// * QUERY FILTRO DEVOLUCION MAQUINA
const QUERY_clientes_registros = gql`
query ($rutEmpresa: Decimal, $sucursalCodigo: Decimal, $codigoRecorrido: Decimal, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
  recorrido_detalle {
    obtenerDetalleRecorrido(rutEmpresa: $rutEmpresa, sucursalCodigo: $sucursalCodigo, codigoRecorrido: $codigoRecorrido, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
      mensajes {
        codigo
        contexto
        texto
        tipo
      }
      respuesta {
        paginaActual
        cantidadRegistrosPorPagina
        totalPaginas
        totalRegistros
        registros {
          recorrido_codigo
          linea
          vendedor_codigo
          rut_emisor
          folio
          tipo_dte_codigo
          ruta_codigo
          cliente_proveedor_rut
          direccion_codigo
          monto_documento
          nombreCliente
          fechaEmisionDocto
          permiteNCParcial
          permiteNCAnulacion
        }
      }
    }
  }
}
        `

@Injectable({
  providedIn: 'root'
})
export class RecorridoDetalleService {


  private clientesDataSubject = new BehaviorSubject(null);
  Clientess$ = this.clientesDataSubject.asObservable();
  postsQuery: QueryRef<any>;
  queryCliente: any;

  constructor(
    private gqlclient: GraphQLClient,
    private apollo: Apollo
  ) { }


  //* DEVUELVE OBSERVABLE CON LA RESPUESTA DE LA QUERY
  getDevolucionFiltro(inputParams): void {
    this.postsQuery = this.apollo.watchQuery<any>({
      query: QUERY_clientes_registros,
      variables: inputParams,
      fetchPolicy: 'network-only'
    })
    this.queryCliente = this.postsQuery.valueChanges.pipe(
      take(1),
      pluck('data', 'recorrido_detalle'),
      withLatestFrom(this.Clientess$),
      tap(([apiResponse, respuesta]) => {
        return apiResponse.obtenerDetalleRecorrido.respuesta
      })
    )
  }

  obtenerDetalleRecorrido(inputParams: {
    rutEmpresa: number,
    sucursalCodigo: number,
    codigoRecorrido: number,
    paginaActual: number,
    cantidadRegistrosPorPagina: number
  }, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($rutEmpresa: Decimal, $sucursalCodigo: Decimal, $codigoRecorrido: Decimal, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          recorrido_detalle {
            obtenerDetalleRecorrido(rutEmpresa: $rutEmpresa, sucursalCodigo: $sucursalCodigo, codigoRecorrido: $codigoRecorrido, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  recorrido_codigo
                  linea
                  vendedor_codigo
                  rut_emisor
                  folio
                  tipo_dte_codigo
                  ruta_codigo
                  cliente_proveedor_rut
                  direccion_codigo
                  monto_documento
                  nombreCliente
                  fechaEmisionDocto
                  permiteNCParcial
                  permiteNCAnulacion
                }
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.recorrido_detalle.obtenerDetalleRecorrido
        callback({ mensajes, respuesta })
      }
    );
  }

  obtenerDataToPdf(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query(
          $recorrido_codigo: Decimal,
          $total_facturas: String,
          $total_documentos: String
        )
        {
          ruteador {
          obtenerDataToPdf(recorrido_codigo: $recorrido_codigo, total_facturas: $total_facturas, total_documentos: $total_documentos) {
            mensajes{
              codigo
              contexto
              tipo
              texto
            }
            respuesta {
              registros {
                pdf_cobranza
                pdf_carga
                pdf_despacho
              }
            }
          }
         }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.ruteador.obtenerDataToPdf
        callback({ mensajes, respuesta })
      }
    );
  }

  obtenerDataToExcel(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($recorrido_codigo: Decimal, $total_facturas: String, $total_documentos: String) {
          ruteador {
            obtenerDataToExcel(recorrido_codigo: $recorrido_codigo, total_facturas: $total_facturas, total_documentos: $total_documentos) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                registros {
                  rutaArchivo
                }
              }
            }
          }
        }

        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.ruteador.obtenerDataToExcel
        callback({ mensajes, respuesta })
      }
    );
  }

  obtenerDetalleRecorridoConAbono(inputParams: {
    rutEmpresa: number,
    sucursalCodigo: number,
    codigoRecorrido: number,
    paginaActual: number,
    cantidadRegistrosPorPagina: number
  }, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($rutEmpresa: Decimal, $sucursalCodigo: Decimal, $codigoRecorrido: Decimal, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          recorrido_detalle {
            obtenerDetalleRecorridoConAbono(rutEmpresa: $rutEmpresa, sucursalCodigo: $sucursalCodigo, codigoRecorrido: $codigoRecorrido, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  abierto
                  cabecera {
                    recorrido_codigo
                    linea
                    vendedor_codigo
                    rut_emisor
                    folio
                    tipo_dte_codigo
                    ruta_codigo
                    cliente_proveedor_rut
                    direccion_codigo
                    monto_documento
                    nombreCliente
                    fechaEmisionDocto
                    fechaVencimientoDocto
                    montoAbonado
                    estado
                    estadoDocumento
                    sucursal_codigo
                    documento
                    condicion_pago_codigo
                  }
                  detalleAbonos {
                    rut_emisor
                    folio
                    tipo_dte_codigo
                    monto_pagado
                    numero_cuenta
                    fecha_documento
                    nro_comprobante_transferencia
                    numero_documento
                    tipo_pago
                    tipo_pago_codigo
                    banco_nombre
                    banco_codigo
                    permite_borrar
                    pago_cuenta
                    tiene_pago_cuenta_por_dentro
                  }
                  detallePagos {
                    codigo
                    fecha_registro
                    efectivo_recaudado
                    cantidad_transferencias
                    monto_deposito
                    monto_cheque
                    monto_abono
                    monto_faltante
                    monto_excente
                    monto_credito
                    monto_nota_credito
                    monto_cargo_ruta
                  }
                }
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.recorrido_detalle.obtenerDetalleRecorridoConAbono
        callback({ mensajes, respuesta })
      }
    );
  }

  eliminarByFolioTipoDocumento(inputParams: {
    entidad: {
      folio: any
      cliente_proveedor_rut: any
      tipo_dte_codigo: any
    }
  }, callback: Function) {
    this.gqlclient.mutate(
      {
        mutation: gql`
        mutation($entidad: recorrido_detalleInputType) {
          recorrido_detalle {
            eliminarByFolioTipoDocumento(entidad: $entidad) {
              mensajes
              {
                codigo
                contexto
                texto
                tipo
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.recorrido_detalle.eliminarByFolioTipoDocumento
        callback({ mensajes, respuesta })
      }
    );
  }

  eliminarRecorrido(inputParams: {
    entidad: {
      recorrido_codigo: number
      rut_emisor: any
    }
  }, callback: Function) {
    this.gqlclient.mutate(
      {
        mutation: gql`
        mutation ($entidad: recorrido_detalleInputType) {
          recorrido_detalle {
            eliminar(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo

              }

            }

          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.recorrido_detalle.eliminar
        callback({ mensajes, respuesta })
      }
    );
  }

  eliminarListaByFolioTipoDocumento(inputParams: {
    entidad: any[]
  }, callback: Function) {
    this.gqlclient.mutate(
      {
        mutation: gql`
        mutation($entidad: lista_recorrido_detalleInputType) {
          recorrido_detalle {
            eliminarListaByFolioTipoDocumento(entidad: $entidad) {
              mensajes
              {
                codigo
                contexto
                texto
                tipo
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        console.log("=>(recorrido-detalle.service.ts:203) response", response);
        const { mensajes, respuesta } = response.data.recorrido_detalle.eliminarListaByFolioTipoDocumento
        callback({ mensajes, respuesta })
      }
    );
  }
  reportePDFDetallePago(inputParams: {
    codigoRecorrido: any
  }, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($codigoRecorrido: Int) {
            liquidacion_recorrido {
              reportePDFDetallePago(recorrido_codigo: $codigoRecorrido) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta{
                  rutaDocumento
                }
              }
            }
          }
          `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.liquidacion_recorrido.reportePDFDetallePago
        callback({ mensajes, respuesta })
      }
    );
  }
  obtenerDiferencialPago(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: liquidacion_diferencia_pagoInputType) {
          liquidacion_recorrido {
            obtenerDiferencialPago(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                tipo
                texto
              }
              respuesta {
                recorridoCodigo
                montoDiferencialEfectivo
                montoDiferencialCheque
                montoDiferencialTransferencia
                montoDiferencialTotal
                montoDiferencialTotalTransportista
                montoDiferencialEfectivoTransportista
                montoDiferencialChequeTransportista
                montoDiferencialTransferenciaTransportista
              }
            }
          }
        }
        `,
        variables: {
          'entidad': inputParams
        },
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.liquidacion_recorrido.obtenerDiferencialPago
        callback({ mensajes, respuesta })
      }
    );
  }

}
